import type { NDateLocale } from './enUS'
import { hy } from 'date-fns/locale'

const dateHyAM: NDateLocale = {
  name: 'hy-AM',
  locale: hy
}

export default dateHyAM
